/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/no-invalid-this */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import {
  Box,
  Grid,
  Chip,
  Button,
  Select,
  MenuItem,
  Popover,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  Autocomplete,
  DialogActions,
  DialogContent,
  FormHelperText
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import _ from 'lodash';
import * as yup from 'yup';
import moment from 'moment';
import { API } from '../../../api';
import MyTooltip from './MyTooltip';
import { toast } from 'react-toastify';
import { CTA_GRADIENT, CTA_GRADIENT_HOVER, buttonDisabledSx } from '../../../components/ui/Buttons/buttonStyles';
import ROLES from '../../../utils/roles';
import BirthdayField from './BirthdayField';
import { AGILE_ORG } from '../../../utils/constants';
import { yupResolver } from '@hookform/resolvers/yup';
import PhoneInput from '../../../constants/PhoneInput';
import { getUserDetails } from '../../../utils/orgName';
import { timezones } from '../../profile-page/timeZones';
import useOrgSettings from '../../../hooks/useOrgSettings';
import { useCapabilityReleaseForMembers } from '../../../hooks/useCapabilityRelease';
import { checkOrfium } from '../../../utils/orfiumFunctions';
import countryCodeArray from '../../../constants/countrycode';
import groupRoleMappings from '../../../utils/groupRoleMappings';
import useProfileDetails from '../../../hooks/useProfileDetails';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { popupActions } from '../../../redux/slices/onboardingPopupsSlice';
import { popupCountActions } from '../../../redux/slices/poupsCountsSlice';
import { validatePhoneNumber } from '../../../constants/PhoneNumberValidator';
import {
  userActions,
  userBioCountUpdate,
  userBioUpdate,
  userInfoUpdate,
  userMemberAttributesUpdate,
  userMemberAttributesChangedUpdate,
  userMemberAttributesAckUpdate,
  userMemberAttributesDeclinedUpdate,
  userTeamRolesUpdate
} from '../../../redux/slices/user-profile/userProfieSlice';
import { Controller, SubmitHandler, FieldValues, useForm } from 'react-hook-form';
import { fetchOrgDetails } from '../../../redux/slices/orgDetails/orgDetailsSlice';
import * as amplitude from '@amplitude/analytics-browser';
import {
  IsAgileExecutive,
  categoryLabelFormatter,
  handleImageCompression,
  imageSizeLimit,
  sortedCountries
} from './common';
import {
  catalogValueIds,
  filterHiddenMemberAttributes,
  unansweredAttributeListIds
} from '../utils/memberAttributes';
import { MEMBER_ATTRIBUTES_HELPER } from './MemberAttributesModal';
import TeamRoleGroups from './TeamRoleGroups';
import {
  initialRoleAnswers,
  roleAnswerLabel,
  roleAnswersPayload,
  roleQuestion,
  roleTeams,
  unansweredAdvice,
  unansweredRoleTeams,
  viewAfterAnswers,
  type RoleAnswers
} from '../utils/teamRoles';

const imgSize = imageSizeLimit();

// Dropdown/menu popups render in a portal OUTSIDE the dialog Paper, so the
// dialog's dark `sx` can't reach them — they'd stay light. These are passed to
// each Autocomplete's paper slot and the Select's menu paper to match the dark
// dialog (bg #1C1C1C, border #2A2A2A, text #FDFDFD, orange selection).
const darkAutocompletePaperSx = {
  bgcolor: '#1C1C1C',
  color: '#FDFDFD',
  backgroundImage: 'none',
  border: '1px solid #2A2A2A',
  '& .MuiAutocomplete-option': { color: '#FDFDFD !important' },
  '& .MuiAutocomplete-option.Mui-focused': { bgcolor: '#262626 !important' },
  '& .MuiAutocomplete-option[aria-selected="true"]': { bgcolor: '#2A2A2A !important' },
  '& .MuiAutocomplete-noOptions, & .MuiAutocomplete-loading': { color: '#68717A' }
};

const darkMenuPaperSx = {
  bgcolor: '#1C1C1C !important',
  color: '#FDFDFD',
  backgroundImage: 'none',
  border: '1px solid #2A2A2A',
  '& .MuiMenuItem-root': { color: '#FDFDFD !important' },
  '& .MuiMenuItem-root:hover': { bgcolor: '#262626 !important' },
  '& .MuiMenuItem-root.Mui-selected': { bgcolor: '#2A2A2A !important' }
};

interface EditProfileFormProps {
  onClose?: () => void;
  /** Dark-surface styling for the portalled popups (dropdowns, calendar,
      phone prefix), the Save button and the bio box. Set by the Personal
      information dialog, whose paper is dark. Leave unset in the sign-up
      wizard: Redirect.tsx renders this same form on a LIGHT surface, where
      the dark overrides made every dropdown unreadable for new users. */
  dark?: boolean;
}

const EditProfileForm = ({ onClose, dark = false }: EditProfileFormProps) => {
  const data = useAppSelector((state) => state.userProfile.data?.personal_details) || {
    firstName: getUserDetails().firstName,
    lastName: getUserDetails().lastName,
    gender: '',
    country: '',
    phoneNumber: '',
    ethnicity: '',
    timezone: '',
    headshot: getUserDetails().picture,
    firstGenStudent: 'No',
    email: getUserDetails().email,
    category: '',
    dob: '',
    phonePrefix: '',
    ftue: false,
    bio: ''
  };
  const programRole = ['Options'];
  const { ftue, lastseen } = useProfileDetails();
  const { userId } = getUserDetails();
  const oid = useAppSelector((state) => state.orgDetails.data?.oid);
  const userData = useAppSelector((state) => state.userProfile.data);
  // "Role in <team>" only when the Capability release is on for members (not in admin mode).
  const forMembers = useCapabilityReleaseForMembers();
  const memberTeamRoles = forMembers ? userData?.teamRoles ?? null : null;

  // Member Attributes — inline selector for onboarding step 1
  const orgMemberAttributes = filterHiddenMemberAttributes(userData?.orgMemberAttributes ?? []);
  const hasOrgMemberAttributes = Array.isArray(orgMemberAttributes) && orgMemberAttributes.length > 0;
  const [selectedAttributeIds, setSelectedAttributeIds] = useState<string[]>(
    () => (Array.isArray(userData?.memberAttributes) ? [...(userData?.memberAttributes ?? [])] : [])
  );
  /** Lists the member answered with "None of these apply to me". */
  const [declinedAttributeListIds, setDeclinedAttributeListIds] = useState<string[]>(
    () =>
      Array.isArray(userData?.memberAttributesDeclinedLists)
        ? [...(userData?.memberAttributesDeclinedLists ?? [])]
        : []
  );
  const [attrError, setAttrError] = useState('');
  const [attrDropdownOpen, setAttrDropdownOpen] = useState(false);
  const attrAnchorRef = useRef<HTMLDivElement>(null);
  /** "Role in <team>" for each team picked that has roles, answered like a list (utils/teamRoles.ts). */
  const [roleAnswers, setRoleAnswers] = useState<RoleAnswers>(() => initialRoleAnswers(memberTeamRoles));
  const teamsWithRoles = roleTeams(memberTeamRoles, orgMemberAttributes, selectedAttributeIds);
  const unansweredRoles = unansweredRoleTeams(teamsWithRoles, roleAnswers);
  const answerRole = (teamValueId: string, roleId: string | null | undefined) => {
    setRoleAnswers((prev) => {
      const next = { ...prev };
      if (roleId === undefined) delete next[teamValueId];
      else next[teamValueId] = roleId;
      return next;
    });
    setAttrError('');
  };
  /**
   * Onboarding must not be finishable with a list untouched. A program's
   * audience ANDs one rule per attribute list, so a member who leaves Office
   * empty matches zero programs and lands on an empty dashboard — which is how
   * RDP members got there. "None of these apply to me" is a valid answer and
   * clears the list; silence is not.
   */
  const unansweredAttributeLists = unansweredAttributeListIds(
    orgMemberAttributes,
    selectedAttributeIds,
    declinedAttributeListIds
  );

  const toggleAttributeValue = (valueId: string, listId: string) => {
    setSelectedAttributeIds((prev) =>
      prev.includes(valueId) ? prev.filter((x) => x !== valueId) : [...prev, valueId]
    );
    setDeclinedAttributeListIds((prev) => prev.filter((x) => x !== listId));
    setAttrError('');
  };

  const toggleAttributeDeclined = (listId: string, valueIds: string[]) => {
    const wasDeclined = declinedAttributeListIds.includes(listId);
    setDeclinedAttributeListIds((prev) =>
      wasDeclined ? prev.filter((x) => x !== listId) : [...prev, listId]
    );
    if (!wasDeclined) {
      const drop = new Set(valueIds);
      setSelectedAttributeIds((prev) => prev.filter((x) => !drop.has(x)));
    }
    setAttrError('');
  };
  const userProfile = useAppSelector((state) => state.userProfile.data?.personal_details);
  const userBioTextCount = useAppSelector((state) => state.userProfile?.bioTextCount);
  const disability = useAppSelector((state) => state.userProfile.data?.personal_details?.disability) || [];
  const optionalFields = _.get(userData, 'settings', {
    gender: false,
    ethnicity: false,
    firstGenerationStudent: false,
    disabilityType: false,
    dob: false,
    country: false,
    category: false,
    timezone: false,
    workHistory: false,
    educationHistory: false,
    hobbiesInterests: false,
    headshot: false,
    bio: false,
    phoneNumber: false
  });

  const popuplength = useAppSelector((state) => state.popupsCount.popuplength);
  const count = useAppSelector((state) => state.popupsCount.count);
  const nextPopUpOrNot = popuplength - count;

  interface CountryType {
    name: string;
    dial_code: string;
    code: string;
  }
  interface OptionalFields {
    country: boolean;
    gender: boolean;
    ethnicity: boolean;
    firstGenerationStudent: boolean;
    category: boolean;
    timezone: boolean;
    workHistory: boolean;
    educationHistory: boolean;
    hobbiesInterests: boolean;
    headshot: boolean;
    bio: boolean;
    phoneNumber: boolean;
  }

  const userTypes = useAppSelector((state) => state?.orgDetails?.data?.userTypes) || [];
  const displayRoles = useAppSelector((state) => state?.orgDetails?.data?.displayRoles);

  // The Member type options mirror the org's role labels from Org Settings
  // ("Name your learners / mentors / admins"): whatever the admin typed there is
  // exactly what shows up here. displayRoles values may be a plain string or a
  // single-item array, so normalise both.
  const roleLabel = (value: unknown, fallback: string): string => {
    const raw = Array.isArray(value) ? value[0] : value;
    return typeof raw === 'string' && raw.trim() ? raw.trim() : fallback;
  };
  const learnerLabel = roleLabel(displayRoles?.mentee, 'Mentee');
  const mentorLabel = roleLabel(displayRoles?.mentor, 'Mentor');
  const adminLabel = roleLabel(displayRoles?.admin, 'Admin');

  // Only users invited as admin (program admin via lastseen, or org admin via
  // the stored platform role) get the admin label as a selectable Member type —
  // everyone else picks from learner / mentor. lastseen.role alone missed org
  // admins, which is why "Admin" never appeared for them before.
  const storedRole = localStorage.getItem('role') || '';
  const isAdminInvitee = lastseen?.role === 'admin' || storedRole === ROLES.orgAdmin;

  const memberTypeOptions = isAdminInvitee ? [learnerLabel, mentorLabel, adminLabel] : [learnerLabel, mentorLabel];

  // Saved category values we accept as-is on load (no forced re-pick): the
  // current labels plus legacy canonical values from earlier versions.
  const knownCategoryValues = [...userTypes, 'admin', 'staff', learnerLabel, mentorLabel, adminLabel];
  // default timezone from orgId
  const isAgileExec = IsAgileExecutive();
  let defaultTz = '';
  if (isAgileExec) {
    const groupRoleObject = groupRoleMappings[AGILE_ORG];
    defaultTz = groupRoleObject['defaultTimezone'];
  }

  function createRequiredTest(fieldName: keyof OptionalFields, errorMessage: string) {
    return function (this: yup.TestContext, value: string | undefined | null) {
      if ((optionalFields as OptionalFields)[fieldName]) {
        if (value) {
          return true; // the field is valid
        } else {
          // the field is invalid, so return a ValidationError object with an error message
          return this.createError({ message: errorMessage });
        }
      } else {
        return true; // the field is not required, so it's always valid
      }
    };
  }

  const schema = yup.object({
    firstName: yup
      .string()
      .required('First name is required')
      .test('no-empty-spaces', 'First name cannot be all empty spaces', (value) => {
        if (value) {
          return !/^[\s]+$/.test(value);
        }
        return true;
      })
      .min(1, 'Name must be at least 1 character')
      .max(25, 'Maximum 25 characters'),
    lastName: yup
      .string()
      .required('Last name is required')
      .test('no-empty-spaces', 'Last name cannot be all empty spaces', (value) => {
        if (value) {
          return !/^[\s]+$/.test(value);
        }
        return true;
      })
      .min(1, 'Name must be at least 1 character')
      .max(25, 'Maximum 25 characters'),

    phoneNumber: yup
      .string()
      .test('is-required', 'Phone number is required', function (value) {
        if (optionalFields.phoneNumber) {
          return !!value || this.createError({ message: 'Phone number is required' });
        }
        return true;
      })
      .test('is-valid-phone-number', 'Invalid phone number', async function (value) {
        if (value && selectedCountry) {
          const { path, createError } = this;
          const validationResult = await validatePhoneNumber(value, selectedCountry);
          if (validationResult) {
            const { isValid, error } = validationResult;
            return isValid || createError({ path, message: error });
          }
          return createError({ path, message: 'Validation error' });
        }
        return true;
      }),

    timezone: yup
      .string()
      .test('is-required', 'Timezone is required', createRequiredTest('timezone', 'Timezone is required')),
    category: yup
      .string()
      .nullable()
      .test(
        'is-required',
        'Type is required',
        function (this: yup.TestContext, value: string | undefined | null) {
          // Required when the org enables the Member type field, or when an
          // admin invitee must pick one during onboarding (ftue) — forced on
          // even if optionalFields.category is off. Existing admins editing
          // their profile later are never newly blocked.
          if (optionalFields.category || (isAdminInvitee && ftue)) {
          return value ? true : this.createError({ message: 'Type is required' });
          }
          return true;
        }
      ),
    dob: yup
      .date()
      .nullable()
      .max(new Date(), 'Date of birth can not be in future')
      .transform((value, originalValue) => {
        if (originalValue === '') {
          return null;
        }
        return value;
      })
      .test('is-required', 'Date of birth is required', function (value) {
        if (optionalFields.dob) {
          if (value) {
            return true;
          } else {
            return this.createError({ message: 'Date of birth is required' });
          }
        } else {
          return true; // the field is not required, so it's always valid
        }
      })
      .typeError('Invalid date format'), // Specify type error message

    country: yup
      .string()
      .test('is-required', 'Country is required', createRequiredTest('country', 'Country is required')),
    gender: yup.string().test('is-required', 'Gender is required', createRequiredTest('gender', 'Gender is required')),
    ethnicity: yup
      .string()
      .test('is-required', 'Ethnicity is required', createRequiredTest('ethnicity', 'Ethnicity is required')),
    firstGenStudent: yup
      .string()
      .test(
        'is-required',
        'First generation student is required',
        createRequiredTest('firstGenerationStudent', 'First generation student is required')
      ),
    bio: yup.string().test('is-required', 'Bio is required', createRequiredTest('bio', 'Bio is required'))

    // headshot: yup
    //   .mixed()
    //   .test('required', 'profile image is required', (value) => value.length > 0)
    //   .test('fileSize', 'File Size is larger than 10 MB', (value) => {
    //     return value.length && value[0].size <= 10485760; // 10 MB in bytes;
    //   })
    //   .test('fileType', 'Unsupported File Format', (value) => {
    //     return (
    //       value.length && ['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml', 'image/gif'].includes(value[0].type)
    //     );
    //   })
  });

  const [loader, setLoader] = useState(false);
  // True while a save is in flight. The `[data]` reset effect below re-runs
  // whenever the Redux profile slice changes — including mid-save, when
  // handleUpdateUserBio() writes bio into personal_details before the profile
  // request returns. Without this guard that reset would wipe the user's
  // in-flight edits (e.g. a just-picked ethnicity) back to the stale slice
  // values. A ref (not state) so it updates synchronously and doesn't re-render.
  const isSavingRef = useRef(false);
  const [headshot, setHeadshot] = useState<any>('');
  const [headshotErr, setHeadshotErr] = useState('');
  const [ftueLoading, setFtueLoading] = useState(false);

  const selectedCountryObject: CountryType | undefined = countryCodeArray.find(
    (country) => country.dial_code === data.phonePrefix
  );

  const [selectedCountry, setSelectedCountry] = React.useState<CountryType | null>(selectedCountryObject || null);

  useEffect(() => {
    setSelectedCountry(() => selectedCountryObject || null);
  }, []);

  const handleCountryChange = (value: CountryType | null) => {
    setSelectedCountry(value);
  };

  const dispatch = useAppDispatch();

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    reset
  } = useForm({
    resolver: yupResolver(schema)
  });

  const loginUserData = useAppSelector((state) => state?.userProfile?.data) || [];

  useEffect(() => {
    if (ftue) {
      const localData = localStorage.getItem('profileData');
      const userData = localData ? JSON.parse(localData) : data;
      setHeadshot(userData.headshot);
    } else {
      setHeadshot(data?.headshot);
    }
  }, []);

  useEffect(() => {
    // Don't clobber the user's in-flight edits while a save is running (a bio
    // write flips the slice mid-save and would otherwise reset the whole form).
    if (isSavingRef.current) return;
    if (ftue) {
      const localData = localStorage.getItem('profileData');
      const userData = localData ? JSON.parse(localData) : data;
      setHeadshot(userData.headshot);
      reset({
        ...userData,
        category: knownCategoryValues.includes(data.category) ? data.category : null
      });
    } else {
      reset({
        ...data,
        category: knownCategoryValues.includes(data.category) ? data.category : null
      });
    }
  }, [data]);

  useEffect(() => {
    const role = localStorage.getItem('role') || '';
    if (role !== ROLES.platAdmin) {
      dispatch(fetchOrgDetails(getUserDetails().orgId));
    }
  }, []);

  useEffect(() => {
    return;
  }, []);

  const userBioData = useAppSelector((state) => state.userProfile.data?.personal_details?.bio);

  const [bioText, setBioText] = useState(userBioData);
  const prevBioText = useRef(bioText);

  const handleUpdateUserBio = async () => {
    if (bioText !== prevBioText.current || bioText === '') {
      const { orgId } = getUserDetails();

      const data = {
        bio: bioText
      };

      try {
        const response = await API.updateBio({ data, orgId });
        if (response.status === 200) {
          // updateBio answers { message, bioData } (no bioData when the bio was cleared)
          dispatch(userBioUpdate(response.data?.bioData ?? bioText));
          dispatch(userBioCountUpdate(bioTextCount));
        }
      } catch {
        toast.error('Your bio could not be saved. Try again.');
      }

      prevBioText.current = bioText;
    }
  };

  // Resolves true only once FTUE is flipped server-side, so the caller knows
  // whether onboarding actually finished.
  const updateFtue = async () => {
    setFtueLoading(true);
    try {
      const response = await API.updateUserFtue({ ftue: false, userId });

      if (response.status === 200) {
        dispatch(userActions.userFtueUpdate(0));
        return true;
      }
    } catch (e) {
      toast.error('Your profile could not be finished. Try again.');
    } finally {
      setFtueLoading(false);
    }
    return false;
  };

  // const onSubmit = async () => {
  //   // if (checkErrors()) {
  //   //   toast.error('Please fill in all required fields');
  //   //   return;
  //   // }

  //   setIsSubmitting(true);

  //   try {
  //     // Prepare data - only include filled objectives
  //     //const objectives = selectedObjectives.slice(0, learningObjectiveCount).filter((obj) => obj);

  //     // API call to save learning objectives
  //     // const response = await API.saveLearningObjectives({
  //     //   userId,
  //     //   objectives,
  //     //   role: isMentor ? 'mentor' : 'mentee'
  //     // });

  //     // if (response.status === 200) {
  //     //   toast.success(`${isMentor ? 'Areas of expertise' : 'Learning objectives'} saved successfully`);

  //       // FTUE logic
  //       if (ftue && nextPopUpOrNot !== 1) {
  //         dispatch(popupCountActions.increment(0));
  //       }
  //       if (nextPopUpOrNot === 1) {
  //         await updateFtue();
  //       }
  //     // } else {
  //     //   toast.error(`Failed to save ${isMentor ? 'areas of expertise' : 'learning objectives'}`);
  //     // }
  //   } catch (error) {
  //     console.error('Error saving learning objectives:', error);
  //     toast.error('An error occurred while saving');
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const onSubmit: SubmitHandler<FieldValues> = async (data) => {
    // Mark the save as in flight before any dispatch so the reset effect leaves
    // the user's current selections untouched until the request resolves.
    isSavingRef.current = true;
    handleUpdateUserBio();
    if (optionalFields.headshot) {
      if (headshot) {
        setHeadshotErr('');
      } else if (optionalFields.headshot) {
        setHeadshotErr('Profile image is required.');
        // Not saving after all — lift the guard so the reset effect keeps
        // syncing the form with the store for the rest of the session.
        isSavingRef.current = false;
        return;
      } else if (!checkOrfium(oid, lastseen?.id || '')) {
        setHeadshotErr('Profile image is required.');
        isSavingRef.current = false;
        return;
      }
    }
    /* Every attribute list must be answered before onboarding can move on —
       a value picked, or "None of these apply to me" ticked. Same guard shape
       as the headshot check above: lift isSavingRef so the form stays live. */
    if (ftue && hasOrgMemberAttributes && (unansweredAttributeLists.length > 0 || unansweredRoles.length > 0)) {
      const lists = orgMemberAttributes.filter((g) => unansweredAttributeLists.includes(g._id)).map((g) => g.name);
      const roles = teamsWithRoles.filter((t) => unansweredRoles.includes(t.teamValueId)).map(roleQuestion);
      // A team's role question offers "My role isn't listed" where a list offers "None of these apply to me".
      const names = [...lists, ...roles].join(', ');
      setAttrError(`Please answer: ${names}. ${unansweredAdvice(lists.length, roles.length)}`);
      setAttrDropdownOpen(true);
      isSavingRef.current = false;
      return;
    }
    localStorage.setItem(
      'profileData',
      JSON.stringify({ ...data, headshot: typeof headshot === 'string' ? headshot : URL.createObjectURL(headshot) })
    );
    let { firstName, lastName, phoneNumber, category, firstGenStudent, timezone, gender, country, ethnicity } = data;
    const identify = new amplitude.Identify();
    identify.set('Member type', category);
    amplitude.identify(identify);
    if (category === null) {
      category = '';
    }
    const submitFormData = new FormData();
    const date = data.dob ? moment(data.dob).format('MM-DD') : '';

    setLoader(true);
    const dataWithId: any = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      phonePrefix: phoneNumber ? selectedCountry?.dial_code || _.get(loginUserData, 'phonePrefix', '') : '',
      phoneNumber,
      category,
      firstGenStudent,
      timezone,
      gender,
      country,
      image: headshot || _.get(loginUserData, 'headshot', ''),
      dob: date,
      ethnicity
      // bio
    };
    // const phoneNumberValidationResult = await validatePhoneNumber(data.phoneNumber, selectedCountry);
    // if (phoneNumberValidationResult && !phoneNumberValidationResult.isValid) {
    //   // Handle invalid phone number...
    //   return;
    // }
    const newData: any = {};
    for (let i in dataWithId) {
      if (i === 'disability') {
        newData[i] = JSON.stringify(dataWithId[i]?.join(','));
      } else {
        newData[i] = dataWithId[i];
      }
    }
    for (let i in newData) {
      submitFormData?.append(i, newData[i]);
    }
    try {
      const response = await API.updateUserProfile({
        orgId: getUserDetails().orgId,
        data: submitFormData
      });
      if (response.status === 200) {
        // Advance the FTUE wizard only AFTER the profile actually saved.
        // Advancing before the request (as before) silently swallowed failures:
        // the user moved on while their first/last name never persisted, which
        // kept personal_details.isActive false and hid them from Org Members.
        // Not gated on isOrgSettings: orgDetails may not be loaded yet during a
        // fresh invitee's FTUE, and a successful save must still advance.
        // On the LAST page, do not advance: moving past the final page showed an
        // empty wizard page with a full progress bar for as long as the remaining
        // requests took. Stay here (button loading) and finish FTUE instead.
        const isLastStep = ftue && nextPopUpOrNot <= 1;
        if (ftue && !isLastStep) {
          dispatch(popupCountActions.increment(0));
        }
        // Save member attributes alongside profile when org has attributes configured (allow empty clear)
        let attributesSaved = false;
        if (hasOrgMemberAttributes) {
          try {
            await API.updateUserMemberAttributes({
              memberAttributes: selectedAttributeIds,
              memberAttributesChanged: false,
              declinedListIds: declinedAttributeListIds,
              ...(memberTeamRoles ? { teamRoles: roleAnswersPayload(teamsWithRoles, roleAnswers) } : {})
            });
            attributesSaved = true;
          } catch {
            // Non-blocking: attributes will be saved next time
          }
        }

        const finished = isLastStep ? await updateFtue() : false;

        // userInfoUpdate replaces the whole userProfile slice with the save
        // response, which still carries ftue=true: applied after the flip it would
        // re-open the FTUE dialog forever, so once FTUE has finished the flag is
        // cleared in the payload. On the last page it is applied only after
        // finishing, so a changed page list cannot flash another wizard page.
        const savedProfile = response?.data?.data;
        if (savedProfile) {
          dispatch(
            userInfoUpdate(
              finished
                ? { ...savedProfile, personal_details: { ...savedProfile.personal_details, ftue: false } }
                : savedProfile
            )
          );
        }
        // Re-apply attributes AFTER userInfoUpdate: the save response predates the
        // attributes save and would otherwise overwrite them, leaving a stale
        // memberAttributesChanged flag that prompts again on the dashboard.
        if (attributesSaved) {
          dispatch(userMemberAttributesUpdate(selectedAttributeIds));
          dispatch(userMemberAttributesChangedUpdate(false));
          dispatch(userMemberAttributesAckUpdate(catalogValueIds(orgMemberAttributes)));
          dispatch(userMemberAttributesDeclinedUpdate(declinedAttributeListIds));
          if (memberTeamRoles) {
            dispatch(
              userTeamRolesUpdate(
                viewAfterAnswers(memberTeamRoles, selectedAttributeIds, teamsWithRoles, roleAnswers)
              )
            );
          }
        }
        setLoader(false);
        dispatch(popupActions.updatePopups({ profile: { open: false, disable: false } }));
        // When opened from the Profile page the dialog is controlled by a local
        // `open` prop (openOverride), not the Redux popup state above — so close
        // it explicitly here. No-op during FTUE (opened via Redux, no onClose).
        onClose?.();
        // disabled for now disability form

        if (!ftue && optionalFields.hobbiesInterests && userProfile?.hobbies.length === 0) {
          dispatch(
            popupActions.updatePopups({
              hobbies: true,
              hobbiesDisable: true
            })
          );
        }
        localStorage.removeItem('profileData');
      }
    } catch (e: any) {
      // Save failed — clear the guard so the form is editable again and keeps
      // the user's values for a retry (the reset effect stays suppressed until
      // the slice next changes, which it hasn't on failure).
      isSavingRef.current = false;
      setLoader(false);
      toast.error(_.get(e, 'response.data.message', 'Your profile could not be saved. Try again.'));
    }
  };

  const checkError = (fieldName: string) => Boolean(errors[fieldName]);
  const getError = (fieldName: string) => errors[fieldName]?.message;
  // const { onChange, ...params } = register('headshot');

  const handlePhotoChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event?.target?.files ? event?.target?.files[0] : null;

    if (!selectedFile) {
      // setHeadshotErr('Profile image is required. Please choose an image.');
      return;
    }
    if (selectedFile && selectedFile.size > imgSize.limitValue) {
      setHeadshotErr('The max file size is 10MB');
      return;
    }
    try {
      const photo = await handleImageCompression(selectedFile);

      if (photo && !['image/jpeg', 'image/png'].includes(photo.type)) {
        setHeadshotErr('Invalid file type. Only JPG, PNG files are allowed.');
      } else {
        setHeadshot(photo);
        setHeadshotErr('');
      }
    } catch (error) {
      console.error('Error handling image compression:', error);
    }
    // if (selectedFile) {
    //   setHeadshot(selectedFile);
    //   setShowCropper(true);
    // }
  };

  // const handleCropDone = (croppedArea: any) => { setShowCropper(false); };
  // const handleCropCancel = () => {
  //   setShowCropper(false);
  //   setHeadshot(null);
  // };

  const genderArray = [
    { name: 'Prefer not to say', value: 'Prefer not to say' },
    { name: 'Male', value: 'Male' },
    { name: 'Female', value: 'Female' },
    { name: 'Non-binary', value: 'Non-binary' }
  ];

  const ethnicityArray = [
    { label: 'Prefer not to say', value: 'Prefer not to say' },
    {
      label: 'American Indian or Alaska Native',
      value: 'American Indian or Alaska Native'
    },
    { label: 'Asian', value: 'Asian' },
    { label: 'Black or African American', value: 'Black or African American' },
    { label: 'Hispanic or Latino', value: 'Hispanic or Latino' },
    {
      label: 'Native Hawaiian or Other Pacific Islander',
      value: 'Native Hawaiian or Other Pacific Islander'
    },
    { label: 'White', value: 'White' }
  ];

  // Surface validation failures: with react-hook-form a failed submit is
  // otherwise completely silent when the offending field isn't on screen.
  const onInvalidSubmit = (formErrors: any) => {
    const first: any = Object.values(formErrors)[0];
    toast.error(typeof first?.message === 'string' ? first.message : 'Please fill in all required fields');
  };

  const getDialogActions = () => {
    return (
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          fullWidth
          onClick={handleSubmit(onSubmit, onInvalidSubmit)}
          // Stay disabled for the whole save (and finish): the wizard now stays on
          // this page until the requests complete, and this blocks double submits.
          disabled={loader || ftueLoading}
          id="personalInfoSubmit"
          sx={
            dark
              ? {
                  // Pin the house primary on the dark dialog: orange gradient
                  // with white text, dark when disabled. The sign-up surface
                  // gets the same look from its theme.
                  background: CTA_GRADIENT,
                  color: '#FDFDFD',
                  fontWeight: 600,
                  '&:hover': { background: CTA_GRADIENT_HOVER, color: '#FDFDFD' },
                  '&.Mui-disabled': buttonDisabledSx
                }
              : undefined
          }
        >
          {loader || ftueLoading ? 'Saving...' : ftue ? (nextPopUpOrNot > 1 ? 'Next' : 'Done') : 'Save'}
        </Button>
      </DialogActions>
    );
  };

  interface FieldTypes {
    fieldName: string;
    component: ReactNode;
  }

  const inputsArray: FieldTypes[] = [
    {
      fieldName: 'gender',
      component: (
        <Grid item xs={12} sm={6}>
          <InputLabel>Gender {optionalFields.gender && '*'}</InputLabel>
          <FormControl fullWidth>
            <Controller
              name="gender"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <Autocomplete
                    size="small"
                    fullWidth
                    id="gender"
                    componentsProps={dark ? { paper: { sx: darkAutocompletePaperSx } } : undefined}
                    options={genderArray}
                    getOptionLabel={(option) => option.name}
                    onChange={(_, option) => onChange(option ? option.value : '')}
                    value={genderArray.find((option) => option.value === value) || null}
                    autoHighlight
                    renderOption={(props, option) => {
                      return (
                        <Box component="li" {...props}>
                          {option.name}
                        </Box>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder="Choose Gender"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'gender'
                        }}
                      />
                    )}
                  />
                );
              }}
            />
            <FormHelperText error>{getError('gender')?.toString()}</FormHelperText>
          </FormControl>
        </Grid>
      )
    },
    {
      fieldName: 'dob',
      component: <BirthdayField control={control} optionalFields={optionalFields} getError={getError} dark={dark} />
    },
    {
      fieldName: 'country',
      component: (
        <Grid item xs={12} sm={6}>
          <InputLabel>Country {optionalFields.country && '*'}</InputLabel>
          <FormControl fullWidth>
            <Controller
              name="country"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <Autocomplete
                    // autoComplete="off"
                    fullWidth
                    size="small"
                    id="country"
                    componentsProps={dark ? { paper: { sx: darkAutocompletePaperSx } } : undefined}
                    options={sortedCountries}
                    getOptionLabel={(option) => option?.label}
                    onChange={(_, option) => onChange(option ? option.code : '')}
                    filterOptions={(options, state) =>
                      options.filter((option) => option.label.toLowerCase().startsWith(state.inputValue.toLowerCase()))
                    }
                    value={sortedCountries?.find((option) => option?.code === value) || null}
                    autoHighlight
                    renderOption={(props, option) => {
                      return (
                        <Box component="li" {...props}>
                          {option.label}
                        </Box>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder="Choose Country"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'country'
                        }}
                      />
                    )}
                  />
                );
              }}
            />
            <FormHelperText error>{getError('country')?.toString()}</FormHelperText>
          </FormControl>
        </Grid>
      )
    },
    {
      fieldName: 'ethnicity',
      component: (
        <Grid item xs={12} sm={6}>
          <InputLabel>Ethnicity {optionalFields.ethnicity && '*'}</InputLabel>
          <FormControl fullWidth>
            <Controller
              name="ethnicity"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <Autocomplete
                    fullWidth
                    size="small"
                    id="ethnicity"
                    componentsProps={dark ? { paper: { sx: darkAutocompletePaperSx } } : undefined}
                    options={
                      ethnicityArray.length > 0
                        ? [
                            ethnicityArray[0],
                            ...ethnicityArray.slice(1).sort((a: any, b: any) => a.label.localeCompare(b.label))
                          ]
                        : []
                    }
                    filterOptions={(options, state) =>
                      options.filter((option) => option.label.toLowerCase().startsWith(state.inputValue.toLowerCase()))
                    }
                    getOptionLabel={(option) => option.label}
                    onChange={(_, option) => onChange(option ? option.value : '')}
                    value={ethnicityArray?.find((option) => option.value === value) || null}
                    autoHighlight
                    renderOption={(props, option) => {
                      return (
                        <Box component="li" {...props}>
                          {option.label}
                        </Box>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder="Choose Ethnicity"
                        autoComplete="false"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'ethnicity'
                        }}
                      />
                    )}
                  />
                );
              }}
            />
            <FormHelperText error>{getError('ethnicity')?.toString()}</FormHelperText>
          </FormControl>
        </Grid>
      )
    },
    {
      fieldName: 'firstGenerationStudent',
      component: (
        <Grid item xs={12} sm={6}>
          <InputLabel>First generation student {optionalFields.firstGenerationStudent && '*'}</InputLabel>
          <FormControl fullWidth>
            <Controller
              control={control}
              name="firstGenStudent"
              render={({ field: { onChange, value } }) => (
                <Select
                  name="firstGenStudent"
                  value={value || ''}
                  id="firstGenStudent"
                  onChange={onChange}
                  fullWidth
                  required
                  error={checkError('firstGenStudent')}
                  displayEmpty
                  MenuProps={dark ? { PaperProps: { sx: darkMenuPaperSx } } : undefined}
                  renderValue={(selected) => {
                    if (!selected) {
                      return <Typography color={dark ? '#50565E' : '#868686'}>Choose an option</Typography>;
                    }
                    return selected;
                  }}
                >
                  {/* <MenuItem value="">Select</MenuItem> */}
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              )}
            />
            <FormHelperText error>{getError('firstGenStudent')?.toString()}</FormHelperText>
          </FormControl>
        </Grid>
      )
    }
  ];

  const isOrgSettings = useOrgSettings();
  const mandatoryFields: FieldTypes[] = [];
  const includedFields: FieldTypes[] = [];
  const optionalFieldsArray: FieldTypes[] = [];

  for (let i in inputsArray) {
    const { fieldName } = inputsArray[i];
    const fieldStatus = (optionalFields as any)[fieldName];
    if (fieldStatus !== undefined) {
      if (fieldStatus) {
        mandatoryFields.push(inputsArray[i]);
      } else {
        includedFields.push(inputsArray[i]);
      }
    } else {
      optionalFieldsArray.push(inputsArray[i]);
    }
  }

  const [bioTextCount, setBioTextCount] = useState(userBioTextCount);

  return (
    <>
      <DialogContent>
        {/* Profile image */}
        {(!ftue || optionalFields.headshot !== undefined) && (
          <Box display="flex" gap={2} alignItems="center">
            <Box className="profileImageBox" position="relative" border={headshotErr ? '1px solid #DC3545' : ''}>
              <label htmlFor="profile-img" className="cursor-pointer">
                <Box className={headshot ? 'ProfileCameraBgOverlay' : 'EdirProfileCameraIcon'}>
                  <CameraAltOutlinedIcon
                    className="CameraIcon"
                    sx={{ color: headshot ? '#FFFFFF' : headshotErr ? '#DC3545' : '#B6B6B6' }}
                  />
                </Box>
                {headshot && (
                  <img
                    className="profileImage"
                    src={typeof headshot === 'string' ? headshot : URL.createObjectURL(headshot)}
                    alt="Group image"
                  />
                )}
              </label>

              <input
                name="headshot"
                accept=".png, .jpeg, .jpg"
                type="file"
                onChange={handlePhotoChange}
                id="profile-img"
                className="img-input-profile-page"
              />
              {/* {showCropper && (
              <ImageCropper
                image={typeof headshot === 'string' ? headshot : URL.createObjectURL(headshot as Blob)}
                onCropDone={handleCropDone}
                onCropCancel={handleCropCancel}
                open={showCropper}  // Pass the state to control the dialog
             />
            )} */}
            </Box>
            <Box>
              <Box display="flex" alignItems="center" gap="8px">
                <Typography variant="h6">Profile image {optionalFields.headshot && '*'}</Typography>
                <Typography variant="body2" className="cursor-pointer" fontWeight="600px" fontSize="10px" color="red">
                  {headshotErr && <FormHelperText error>{headshotErr}</FormHelperText>}
                </Typography>
              </Box>
              <Typography fontSize="10px" fontWeight="600" sx={{ color: '#999999' }} mt={0.5}>
                jpg or png (max size {imgSize.limitText}, ideal dimensions 800x800 px)
              </Typography>
            </Box>
          </Box>
        )}

        {/* Profile information fields */}
        <Box mt={2}>
          <Grid container spacing={2}>
            {/* First name */}
            <Grid item xs={12} sm={6}>
              <InputLabel>First name *</InputLabel>
              <Controller
                name="firstName"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    size="small"
                    required
                    name="firstName"
                    value={value}
                    id="firstName"
                    data-testid="first-name-input"
                    type="text"
                    placeholder="John"
                    variant="outlined"
                    onChange={onChange}
                    error={checkError('firstName')}
                    helperText={getError('firstName')?.toString()}
                  />
                )}
              />
            </Grid>

            {/* Last name */}
            <Grid item xs={12} sm={6}>
              <InputLabel>Last name *</InputLabel>
              <Controller
                name="lastName"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    required
                    size="small"
                    name="lastName"
                    value={value}
                    type="text"
                    id="lastName"
                    data-testid="last-name-input"
                    placeholder="Smith"
                    variant="outlined"
                    style={{ width: '100%', fontWeight: '600' }}
                    onChange={onChange}
                    error={checkError('lastName')}
                    helperText={getError('lastName')?.toString()}
                  />
                )}
              />
            </Grid>

            {/* Email */}
            <Grid item xs={12} sm={isOrgSettings ? 6 : 12}>
              <InputLabel>Email *</InputLabel>
              <Controller
                name="email"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    required
                    size="small"
                    name="email"
                    // value={value}
                    id="email"
                    type="email"
                    placeholder="john@gmail.com"
                    defaultValue={getUserDetails().email}
                    variant="outlined"
                    style={{
                      width: '100%',
                      background: '#151515',
                      padding: '14.5px !important'
                    }}
                    onChange={onChange}
                    error={checkError('email')}
                    helperText={getError('email')?.toString()}
                    disabled
                  />
                )}
              />
            </Grid>

            {/* Time Zone — must render whenever the org marks it required
                (settings.timezone), even before orgDetails loads: a required
                field that never renders blocks submit with no visible error. */}
            {(isOrgSettings || optionalFields.timezone) && (
              <Grid item xs={12} sm={6}>
                <InputLabel>Time Zone *</InputLabel>
                <FormControl fullWidth>
                  <Controller
                    name="timezone"
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      const defaultValue = value || defaultTz;
                      if (!value && defaultValue) {
                        onChange(defaultValue);
                      }
                      return (
                        <Autocomplete
                          fullWidth
                          size="small"
                          id="timeZone"
                          componentsProps={dark ? { paper: { sx: darkAutocompletePaperSx } } : undefined}
                          options={timezones}
                          getOptionLabel={(option) => option?.timezoneDisplayNames}
                          onChange={(_, option) => onChange(option ? option.value : '')}
                          value={timezones.find((option) => option.value === defaultValue) || null}
                          autoHighlight
                          renderOption={(props, option) => {
                            return (
                              <Box component="li" {...props}>
                                {option.timezoneDisplayNames}
                              </Box>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              size="small"
                              placeholder="Choose Timezone"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'timezone'
                              }}
                            />
                          )}
                        />
                      );
                    }}
                  />
                  <FormHelperText error>{getError('timezone')?.toString()}</FormHelperText>
                </FormControl>
              </Grid>
            )}

            {/* Member Attributes — shown during onboarding when org has attribute groups */}
            {ftue && hasOrgMemberAttributes && (
              <Grid item xs={12}>
                {/* Required: onboarding cannot be finished with a list untouched
                    (every list needs a value or an explicit "None of these apply
                    to me"), so the label carries the same trailing asterisk as
                    the other mandatory fields on this form. */}
                <InputLabel>Select my Attributes*</InputLabel>
                <Box sx={{ position: 'relative', width: '100%' }}>
                  <Box
                    ref={attrAnchorRef}
                    component="div"
                    onClick={() => setAttrDropdownOpen((o) => !o)}
                    sx={{
                      width: '100%',
                      height: 40,
                      px: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      border: '1px solid',
                      borderColor: attrDropdownOpen ? '#F79420' : '#2A2A2A',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      bgcolor: '#1C1C1C',
                      '&:hover': { borderColor: '#444444' }
                    }}
                  >
                    {/* The box must stay one line tall no matter how many
                        attributes are picked — extra selections remain viewable
                        by scrolling horizontally inside the line. */}
                    <Box
                      sx={{
                        flex: 1,
                        minWidth: 0,
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        gap: 0.5,
                        overflowX: 'auto',
                        scrollbarWidth: 'thin',
                        '&::-webkit-scrollbar': { height: 4 },
                        '&::-webkit-scrollbar-thumb': { backgroundColor: '#444444', borderRadius: 2 },
                        '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' }
                      }}
                    >
                      {selectedAttributeIds.length === 0 &&
                      declinedAttributeListIds.length === 0 &&
                      teamsWithRoles.length === 0 ? (
                        <Typography sx={{ color: '#868686', fontSize: 14, whiteSpace: 'nowrap' }}>
                          Select attributes...
                        </Typography>
                      ) : (
                        <>
                          {selectedAttributeIds.map((id) => {
                            const match = orgMemberAttributes
                              .flatMap((g) => g.values.map((v) => ({ ...v, groupId: g._id })))
                              .find((v) => v._id === id);
                            if (!match) return null;
                            return (
                              <Chip
                                key={id}
                                label={match.value}
                                size="small"
                                onDelete={(e: React.MouseEvent) => {
                                  e.stopPropagation();
                                  setSelectedAttributeIds((prev) => prev.filter((x) => x !== id));
                                }}
                                deleteIcon={<CloseIcon sx={{ fontSize: 14, color: '#B6B6B6' }} />}
                                sx={{
                                  height: 24,
                                  fontSize: 12,
                                  flexShrink: 0,
                                  bgcolor: 'rgba(255,255,255,0.12)',
                                  color: '#FDFDFD',
                                  '& .MuiChip-deleteIcon': { color: '#B6B6B6', '&:hover': { color: '#FDFDFD' } }
                                }}
                              />
                            );
                          })}
                          {/* A declined list is an answer, so it gets a chip too —
                              otherwise a fully answered catalog looks empty. */}
                          {declinedAttributeListIds.map((listId) => {
                            const group = orgMemberAttributes.find((g) => g._id === listId);
                            if (!group) return null;
                            return (
                              <Chip
                                key={`${listId}::none`}
                                label={`${group.name}: None`}
                                size="small"
                                onDelete={(e: React.MouseEvent) => {
                                  e.stopPropagation();
                                  setDeclinedAttributeListIds((prev) => prev.filter((x) => x !== listId));
                                }}
                                deleteIcon={<CloseIcon sx={{ fontSize: 14, color: '#B6B6B6' }} />}
                                sx={{
                                  height: 24,
                                  fontSize: 12,
                                  flexShrink: 0,
                                  bgcolor: 'rgba(255,255,255,0.06)',
                                  color: '#B6B6B6',
                                  '& .MuiChip-deleteIcon': { color: '#B6B6B6', '&:hover': { color: '#FDFDFD' } }
                                }}
                              />
                            );
                          })}
                        </>
                      )}
                    </Box>
                    <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                      <Box
                        sx={{
                          width: 0,
                          height: 0,
                          borderLeft: '5px solid transparent',
                          borderRight: '5px solid transparent',
                          borderTop: '5px solid #B6B6B6',
                          transform: attrDropdownOpen ? 'rotate(180deg)' : 'none',
                          transition: 'transform 0.2s'
                        }}
                      />
                    </Box>
                  </Box>
                  <Popover
                    open={attrDropdownOpen}
                    anchorEl={attrAnchorRef.current}
                    onClose={() => setAttrDropdownOpen(false)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    disableAutoFocus
                    disableEnforceFocus
                    PaperProps={{
                      sx: {
                        width: attrAnchorRef.current?.offsetWidth || 400,
                        maxHeight: 300,
                        mt: 0.5,
                        background: '#1C1C1C !important',
                        color: '#FDFDFD !important',
                        border: '1px solid #2A2A2A !important',
                        boxShadow: '0 12px 32px -12px rgba(0,0,0,0.8) !important',
                        borderRadius: 1,
                        overflow: 'hidden'
                      }
                    }}
                  >
                    <Box sx={{ overflow: 'auto', maxHeight: 300 }}>
                      {orgMemberAttributes.map((group) => {
                        const groupDeclined = declinedAttributeListIds.includes(group._id);
                        const groupUnanswered = unansweredAttributeLists.includes(group._id);
                        return (
                          <Box key={group._id}>
                            <Box
                              sx={{
                                px: 2,
                                pt: 1,
                                pb: 0.25,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                              }}
                            >
                              <Typography
                                sx={{
                                  color: '#868686',
                                  fontSize: 12,
                                  fontWeight: 600,
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px'
                                }}
                              >
                                {group.name}
                              </Typography>
                              {groupUnanswered && (
                                <Typography sx={{ color: '#F79420', fontSize: 11, fontWeight: 500 }}>
                                  Needs an answer
                                </Typography>
                              )}
                            </Box>
                            {group.values.map((v) => {
                              const selected = selectedAttributeIds.includes(v._id);
                              return (
                                <Box
                                  key={v._id}
                                  component="button"
                                  type="button"
                                  onClick={() => toggleAttributeValue(v._id, group._id)}
                                  sx={{
                                    width: '100%',
                                    px: 2,
                                    py: 0.75,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    border: 'none',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    '&:hover': { bgcolor: 'rgba(255,255,255,0.06)' }
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 18,
                                      height: 18,
                                      borderRadius: '3px',
                                      border: '2px solid',
                                      borderColor: selected ? '#F79420' : '#565656',
                                      bgcolor: selected ? '#F79420' : 'transparent',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      flexShrink: 0
                                    }}
                                  >
                                    {selected && <CheckIcon sx={{ fontSize: 14, color: '#fff' }} />}
                                  </Box>
                                  <Typography sx={{ fontSize: 14, color: '#FDFDFD' }}>
                                    {v.value}
                                  </Typography>
                                </Box>
                              );
                            })}
                            {/* The escape hatch that keeps "every list answered"
                                answerable — a list nobody is in ("Management:
                                Managers | SLT") is declined, not left silent. */}
                            <Box
                              component="button"
                              type="button"
                              onClick={() =>
                                toggleAttributeDeclined(
                                  group._id,
                                  group.values.map((v) => v._id)
                                )
                              }
                              sx={{
                                width: '100%',
                                px: 2,
                                py: 0.75,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                border: 'none',
                                background: 'transparent',
                                cursor: 'pointer',
                                textAlign: 'left',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.06)' }
                              }}
                            >
                              <Box
                                sx={{
                                  width: 18,
                                  height: 18,
                                  borderRadius: '3px',
                                  border: '2px solid',
                                  borderColor: groupDeclined ? '#F79420' : '#565656',
                                  bgcolor: groupDeclined ? '#F79420' : 'transparent',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  flexShrink: 0
                                }}
                              >
                                {groupDeclined && <CheckIcon sx={{ fontSize: 14, color: '#fff' }} />}
                              </Box>
                              <Typography
                                sx={{ fontSize: 14, color: '#B6B6B6', fontStyle: 'italic' }}
                              >
                                None of these apply to me
                              </Typography>
                            </Box>
                            {/* "Role in <team>" directly under the Teams list: only the roles of the teams picked. */}
                            {group._id === memberTeamRoles?.teamsListId && (
                              <TeamRoleGroups
                                teams={teamsWithRoles}
                                answers={roleAnswers}
                                onAnswer={answerRole}
                                look="onboarding"
                              />
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  </Popover>
                </Box>
                <FormHelperText sx={{ mt: 0.5 }}>{MEMBER_ATTRIBUTES_HELPER}</FormHelperText>
                {attrError && (
                  <FormHelperText error sx={{ mt: 0.5 }}>
                    {attrError}
                  </FormHelperText>
                )}
              </Grid>
            )}

            {/* Member type — options come from the org's role labels; admin
                invitees additionally see the admin label. Forced visible for
                admin invitees ONLY during onboarding (ftue), so existing admins
                editing their profile aren't disrupted. */}
            {(optionalFields.category || (isAdminInvitee && ftue)) && (
              <Grid item xs={12} sm={6}>
                <InputLabel>Type*</InputLabel>
                <FormControl fullWidth>
                  <Controller
                    name="category"
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      return (
                        <Autocomplete
                          fullWidth
                          size="small"
                          id="userType"
                          componentsProps={dark ? { paper: { sx: darkAutocompletePaperSx } } : undefined}
                          options={memberTypeOptions}
                          getOptionLabel={(option) => categoryLabelFormatter(option)}
                          onChange={(_, option) => onChange(option ? option : '')}
                          value={value || null}
                          autoHighlight
                          isOptionEqualToValue={(option, value) => option === value || value === ''}
                          renderOption={(props, option) => {
                            return (
                              <Box component="li" {...props}>
                                {categoryLabelFormatter(option)}
                              </Box>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              size="small"
                              placeholder="Choose type"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'category'
                              }}
                            />
                          )}
                        />
                      );
                    }}
                  />
                  <FormHelperText error>{getError('category')?.toString()}</FormHelperText>
                </FormControl>
              </Grid>
            )}

            {/* Program role */}
            {/* <Grid item xs={12} sm={6}>
              <InputLabel>Program role *</InputLabel>
              <FormControl fullWidth>
                <Controller
                  name="programRole"
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <Autocomplete
                        fullWidth
                        size="small"
                        id="programRole"
                        options={programRole}
                        getOptionLabel={(option) => option} 
                        onChange={(_, option) => onChange(option ? option : '')}
                        value={value || null}
                        autoHighlight
                        isOptionEqualToValue={(option, value) => option === value || value === ''}
                        renderOption={(props, option) => (
                          <Box component="li" {...props}>
                            {option}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            size="small"
                            placeholder="Choose Program role"
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                    );
                  }}
                />
              </FormControl>
            </Grid> */}

            {mandatoryFields.map((item) => item.component)}
            {includedFields.map((item) => item.component)}
            {!ftue && optionalFieldsArray.map((item) => item.component)}

            {/* Phone number — during FTUE it must render whenever the org
                configures it (settings.phoneNumber), even before orgDetails
                loads: a required field that never renders blocks submit with
                no way to fix it (same failure mode as Time Zone above). */}
            {(ftue ? optionalFields.phoneNumber !== undefined : isOrgSettings) && (
              <Grid item xs={12} sm={6}>
                <PhoneInput
                  countryCodeArray={countryCodeArray}
                  data={data}
                  control={control}
                  errors={errors}
                  onChange={handleCountryChange}
                  name="phoneNumber"
                  showMark={false}
                  required={optionalFields.phoneNumber}
                  paperSx={dark ? darkAutocompletePaperSx : undefined}
                />
              </Grid>
            )}

            {/* Bio */}
            {(!ftue || optionalFields.bio !== undefined) && (
              <Grid item xs={12} sm={12} md={12}>
                <Grid container justifyContent="space-between" alignItems="center">
                  <Grid item>
                    <InputLabel>
                      Bio {optionalFields.bio && '*'}
                      {ftue && (
                        <MyTooltip title="You can always add or edit via your profile later" placement="right" />
                      )}
                    </InputLabel>
                  </Grid>
                  <Grid item>
                    <InputLabel>{bioTextCount || userBioTextCount}/2000</InputLabel>
                  </Grid>
                </Grid>

                <Controller
                  name="bio"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      required
                      name="bio"
                      value={value}
                      id="bio"
                      data-testid="bio-input"
                      type="text"
                      multiline
                      maxRows={4}
                      rows={4}
                      fullWidth
                      inputProps={{
                        maxLength: 2000
                      }}
                      placeholder="Write a little bit about yourself, your educational, and professional experience..."
                      onChange={(event) => {
                        onChange(event);
                        setBioTextCount(event.target.value?.split('')?.length);
                        setBioText(event.target.value);
                      }}
                      error={checkError('bio')}
                      helperText={getError('bio')?.toString()}
                    />
                  )}
                />
              </Grid>
            )}
          </Grid>
        </Box>
      </DialogContent>

      {/* Dialog actions */}
      {getDialogActions()}
    </>
  );
};

export default EditProfileForm;
